import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'empusa-app';
  showStartup = true;
  showEnvanetBackground = environment.showEnvanetBackground ?? true;
  private routerSub?: Subscription;

  constructor(private router: Router) {
    window.onbeforeunload = function () {};
  }

  ngOnInit(): void {
    // If maintenance mode is active, skip the startup overlay so maintenance shows immediately
    if ((<any>environment).maintenanceMode) {
      this.showStartup = false;
      return;
    }

    // Hide startup overlay after the app router finishes the initial navigation
    this.routerSub = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.showStartup = false;
      this.routerSub?.unsubscribe();
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

}
